export const urlParse = function() {

    let res = {}
    const urlSplit = window.location.pathname.split('/')
    const urlLength = urlSplit.length

    if (urlSplit[1] === 'detail') {
        res.item_id = urlSplit[2]
        if (urlSplit[3] !== undefined && urlSplit[3] !== '') {
            res.mall_id = urlSplit[3]
        }
    } else if (urlLength > 2) {
        res.item_id = urlSplit[2]
        if (urlSplit[3] !== undefined && urlSplit[3] !== '') {
            res.mall_id = urlSplit[3]
        }
    }
    return res
}



// WEBPACK FOOTER //
// ./src/m_header/utils/util.js